<navbar></navbar>
<div class="container bg-white">
    <div class="row">
        <div class="col">
            <h1>Leaderboard</h1>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <ul class="list-group" style="padding-bottom: 1em;">
                <li *ngFor="let team of teams" class="list-group-item d-flex w-100 justify-content-between">
                    <span>{{ team.name }}</span>
                    <span>{{ team.total }} PTS</span>
                </li>
            </ul>
        </div>
  </div>
</div>